import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Cards.es.js";
const r = o.forwardRef((a, e) => /* @__PURE__ */ o.createElement(s, { ref: e, ...a, weights: t }));
r.displayName = "CardsIcon";
const n = r;
export {
  n as Cards,
  r as CardsIcon
};
